<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="editCity" (change)="editCityChange()" (submit)="editCitySubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{ "EDIT_CITY" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="reset" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/system/cities"
                    *ngIf="!creating">
                    {{ "CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                        class="fas fa-plus"></i>
                        {{ "SAVE" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>


        </div>

        <div class="row mt-4">

            <div class="col-12">

                <div class="row bg-white border m-0 py-3 ">
                    <div class="col-md-10 mx-md-auto pt-md-5 px-md-5">
                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{ "COUNTRY" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="country"
                                    (change)="changeCountry()">
                                    <option value="" [selected]="true">Select</option>
                                    <option *ngFor="let res of countries" [ngValue]="res.id">{{
                                            (globals.lang == 'ar')? res.countryNameAr : res.countryNameEn
                                            }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="editCity.controls.country.touched && editCity.controls.country.invalid && editCity.dirty">
                                    {{"PLEASE_SELECT_A_COUNTRY" | translate | titlecase}}
                                </div>
                            </div>

                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{ "REGION" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="region"
                                    (change)="changeRegion()">
                                    <option value="" [selected]="true">Select</option>
                                    <option *ngFor="let res of regions" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.regionNameAr : res.regionNameEn
                                        }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="editCity.controls.region.touched && editCity.controls.region.invalid && editCity.dirty">
                                    {{"PLEASE_SELECT_A_REGION" | translate | titlecase}}
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{"PROVINCE" | translate | titlecase}}</label>
                                <select class="form-control custom-select" formControlName="province"
                                    (change)="changeProvince()">
                                    <option value="" [selected]="true">Select</option>
                                    <option *ngFor="let res of provinces" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.provinceNameAr : res.provinceNameEn
                                        }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="editCity.controls.province.touched && editCity.controls.province.invalid && editCity.dirty">
                                    {{"PLEASE_SELECT_A_PROVINCE" | translate | titlecase}}
                                </div>
                            </div>
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{"CITY_NAME_AR" | translate | titlecase}}</label>
                                <input type="text" class="form-control" formControlName="cityNameAr">
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="editCity.controls.cityNameAr.touched && editCity.controls.cityNameAr.invalid && editCity.dirty">
                                    {{ "PLEASE_ENTER_VALID_DATA" | translate | titlecase }}
                                </div>
                            </div>
                           
                        </div>
                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{"CITY_NAME_EN" | translate | titlecase}}</label>
                                <input type="text" class="form-control" formControlName="cityNameEn">
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="editCity.controls.cityNameEn.touched && editCity.controls.cityNameEn.invalid && editCity.dirty">
                                    {{ "PLEASE_ENTER_VALID_DATA" | translate | titlecase }}
                                </div>
                            </div>
                            <!-- <div class="col-md-6 align-self-end">
                                <label class="font-bold">Dict Id </label>
                                <input type="text" class="form-control" formControlName="dictId">
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="editCity.controls.dictId.touched && editCity.controls.dictId.invalid && editCity.dirty">
                                    Please enter a valid dict Id
                                </div>
                            </div> -->
                        </div>


                    </div>
                </div>
            </div>


        </div>

    </form>
</div>

<app-loader [show]="showLoader"></app-loader>